import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import apiUrl from "../api";

import axios from "axios";

const AddPoolOption = () => {
  const [poolName, setPoolName] = useState("");
  const [poolPrice, setPoolPrice] = useState(0); // Default price is 0
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleAddPool = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (poolName === "") {
      return setError("Pool Option name is required.");
    }

    // Add API call to add the pool option
    try {
      const response = await axios.post(
        `${apiUrl}/pool-options/createPoolOption`,
        {
          title: poolName,
          price: poolPrice
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Pool option added successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Pool option already exists.");
      } else {
        setError("Failed to add pool option. Please try again.");
      }
    }

    setPoolName("");
    setPoolPrice(0); // Reset price to default after adding the pool option
  };

  return (
    <div className="add-pool-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "0px",
          fontWeight: "600",
        }}
      >
        Add Pool Option
      </h4>
      <form
        onSubmit={handleAddPool}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          alignItems: "center",
        }}
      >
        <TextField
          variant="outlined"
          label="Pool Option Name"
          placeholder="Pool Option Name"
          value={poolName}
          onChange={(e) => setPoolName(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } },
          }}
        />
        <TextField
          variant="outlined"
          type="number"
          label="Price"
          placeholder="Price"
          value={poolPrice}
          onChange={(e) => setPoolPrice(Number(e.target.value))}
          margin="normal"
          sx={{
            width: "20%",
          }}
          InputProps={{
            inputProps: { 
              style: { height: "56px", padding: "5px" },
              min: 0,
              step: "0.01"
            },
          }}
        />
        <button
          type="submit"
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "10px 20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "56px",
            marginTop: "16px",
          }}
        >
          <AddIcon />
          Add
        </button>
      </form>
    </div>
  );
};

export default AddPoolOption;